import {useEffect} from 'react'
const Logout = () => {
  useEffect(() => {
    localStorage.clear();
    window.location.href = process.env.REACT_APP_COGNITO_SHIB_LOGOUT_URL;
  }, []);
}

export default Logout